<template>
  <div
    class="vinput"
    :class="{
      loading: loading,
      error: !!error || hasError,
      focus_area,
      border: border,
      application: application,
      'custom-online': custom_online,
      'border-none': border === 'none'
    }"
  >
    <input
      :id="id"
      ref="input"
      v-validate="validate"
      :class="['input', { center }, { filled: focus_area && value && value.length }, { search: icon === 'search' }]"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :value="value"
      :disabled="disabled || loading"
      :required="required"
      :maxlength="max"
      :autocomplete="autocomplete"
      @change="input"
      @input="input"
      @keydown="keydown"
      @keyup="keyup"
      @keyup.enter="enter"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />

    <div v-if="clearable" class="vinput__clear" @click="$emit('clear')">
      <span>&times;</span>
    </div>

    <label v-if="label" :for="id">{{ label }}</label>

    <div v-if="!!error" class="message">{{ error }}</div>
  </div>
</template>

<script>
// ref убирать нельзя есть зависимость у телефона
export default {
  name: 'Vinput',

  props: {
    value: {
      type: [String, Number],
      default: ''
    },

    name: {
      type: [String, Number],
      default: ''
    },

    loading: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: [String, Number],
      default: ''
    },

    clearable: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'text'
    },

    label: {
      type: String,
      default: ''
    },

    center: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    valuetype: {
      // any, number(реализовано), email, phone
      type: String,
      default: 'any'
    },

    id: {
      type: String,
      default: null
    },

    focus: {
      type: Boolean,
      default: false
    },

    hasError: {
      type: Boolean,
      default: false
    },

    focus_area: {
      // бордер при фокусе
      type: Boolean,
      default: false
    },

    validate: {
      type: String,
      default: ''
    },

    error: {
      // сообщение об ошибке
      type: String,
      default: ''
    },

    min: {
      type: [Number, Boolean],
      default: false
    },

    max: {
      type: [Number, Boolean],
      default: false
    },

    border: {
      // обводка инпута классическая
      type: [Boolean, String],
      default: false
    },

    icon: {
      // search, none
      type: String,
      default: 'none'
    },

    required: {
      type: Boolean,
      default: false
    },

    input_event: {
      // отсылать вместо значения, событие ввода при инпуте
      type: Boolean,
      default: false
    },

    application: {
      type: Boolean,
      default: false
    },

    custom_online: {
      type: Boolean,
      default: false
    },

    autocomplete: {
      type: String,
      default: 'on'
    }
  },

  data() {
    return {
      key: '',
      ctrl: false
    };
  },

  computed: {
    isValid() {
      if (!this.validate) {
        return true;
      }
      const fields = Object.keys(this.fields).map(k => this.fields[k]);
      return fields.every(f => f.valid === true);
    }
  },

  watch: {
    isValid: {
      immediate: true,
      handler(val) {
        this.$emit('setValid', val);
      }
    }
  },

  mounted() {
    if (this.focus) {
      this.$refs.input.focus();
    }
  },

  methods: {
    input(e) {
      let result = e.target.value;

      if (this.input_event) {
        result = e;
      }
      this.$emit('input', result);
    },

    keydown(e) {
      this.key = e.key;
      if (navigator.appVersion.indexOf('Mac') === -1) {
        // если мак
        this.ctrl = e.ctrlKey;
      } else {
        if (e.keyCode === 91 || e.keyCode === 93) {
          // если нажали cmd
          this.ctrl = true;
        }
      }
      if (e.key && e.key.length && e.key.length === 1 && this.ctrl === false) {
        switch (this.valuetype) {
          case 'number': {
            if (this.check_number(e.key) === false) {
              e.preventDefault();
              return false;
            } else {
              // ограничение пока если минимум меньше 10
              if (this.$refs.input.value.length === 0 && Number(e.key) < this.min && this.min < 10) {
                e.preventDefault();
                return false;
              }
            }
            break;
          }
          case 'phone': {
            if (this.check_phone(e.key) === false) {
              e.preventDefault();
              return false;
            }
            break;
          }
        }
      }
      this.$emit('keydown', e);
    },

    check_phone(v) {
      if (v.match(/[0-9, /+, ]/g) === null) {
        return false;
      }
      return true;
    },

    check_number(v) {
      if (v.match(/[0-9]/g) === null) {
        return false;
      }
      return true;
    },

    keyup(e) {
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        if (e.keyCode === 91 || e.keyCode === 93) {
          this.ctrl = false;
        }
      }
      this.$emit('keyup', e);
      // дополнительная валидация после ввода
    },

    enter(e) {
      this.$emit('enter', e);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';
.vinput {
  display: flex;
  position: relative;

  &__clear {
    width: 32px;
    height: 100%;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    font-size: 24px;
    color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: darken(#ccc, 10%);
      transition: color 0.3s;
    }
  }

  &.application {
    .input {
      padding: 0;
      min-height: 25px;
      max-height: 25px;
      height: 25px;
    }
  }
  &.custom-online {
    .input {
      padding: 5px 12px;
      min-height: 33px;
      max-height: 33px;
      height: 33px;
    }
  }
  .input {
    min-width: 100%;
    max-width: 100%;
    display: block;
    padding: 10px 12px;
    margin: 0;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #d2d6e0;
    @include mixin-text-main;
    color: $black;
    height: auto !important;
    min-height: 40px;
    max-height: 40px;
    height: 40px;
    background-color: #fff;

    &.center {
      text-align: center;
    }

    &:disabled {
      background-color: #fff;
    }

    &:focus ~ label {
      transform-origin: left;
      font-size: 13px;
      transform: translateY(0px);
    }

    &.filled {
      border-bottom: 1px solid $green;
    }

    &.filled ~ label {
      transform-origin: left;
      font-size: 13px;
      transform: translateY(0px);
    }

    &.search {
      background: url(/static/icons/search.svg) 10px center no-repeat;
      background-size: 15px 15px;
      padding-left: 35px;
    }

    &.invalid {
      border: 2px solid #ad2a2a !important;
    }
  }

  &.border {
    .input {
      border: 1px solid $grey-light;
      border-radius: 2px;
      transition: border 0.4s;

      &:focus {
        border: 1px solid $green;
        transition: border 0.4s;
      }
    }
    &.focus_area {
      .input {
        &:focus {
          border: 1px solid $green;
        }
        &.filled {
          border: 1px solid $green;
        }
      }
    }
    &-none {
      .input {
        border-bottom: 0;
      }
    }
  }
  &.focus_area .input:focus {
    border-bottom: 1px solid $green;
  }

  & label {
    color: #9faab6;
    font-size: 15px;
    transition: 0.2s ease all;
    cursor: pointer;
    position: absolute;
    bottom: 30px;
    left: 10px;
    transform: translateY(20px);
  }
  &.error {
    flex-direction: column;
    .input {
      border-color: #f65046;
    }
    & label {
      bottom: 52px;
    }
    .message {
      @include mixin-text-tag;
      color: #f65046;
      margin-top: 5px;
      margin-left: 10px;
    }
  }
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
